module.exports = "<div>\n  <div *ngFor=\"let error of errors\" class=\"alert alert-danger\" role=\"alert\" [innerHTML]=\"error\">\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/errors/errors.component.html
// module id = ../../../../../src/app/shared/errors/errors.component.html
// module chunks = 2